import { render, staticRenderFns } from "./TabsCommunicationTemplate.vue?vue&type=template&id=8f162e64&"
import script from "./TabsCommunicationTemplate.vue?vue&type=script&lang=js&"
export * from "./TabsCommunicationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports